import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage  }) => {
  const [formData, setFormData] = useState({
    message: '',
    mode: '',
    openingBal: '',
    amount: '',
    closingBal: '',
    utr: '',
    orderId: '',
    refId: '',
    // userId: '',
    date: '',
    recorn: '',
    refund: '',
    service: '',
    customerName: '',
    cardNumber: '',
    time: '',

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};
    if (formData.message === '') {
      formErrors.message = 'Message cannot be empty';
    }

    if (formData.mode === '') {
      formErrors.mode = 'Mode cannot be empty';
    }

    if (formData.openingBal === '') {
      formErrors.openingBal = 'Opening Balance cannot be empty';
    }

    if (formData.amount === '') {
      formErrors.amount = 'Amount cannot be empty';
    }

    if (formData.closingBal === '') {
      formErrors.closingBal = 'Closing Balance cannot be empty';
    }

    if (formData.utr === '') {
      formErrors.utr = 'UTR cannot be empty';
    }

    if (formData.orderId === '') {
      formErrors.orderId = 'Order ID cannot be empty';
    }

    if (formData.refId === '') {
      formErrors.refId = 'Reference ID cannot be empty';
    }

    if (formData.date === '') {
      formErrors.date = 'Date cannot be empty';
    }

    if (formData.recorn === '') {
      formErrors.recorn = 'Recorn cannot be empty';
    }

    if (formData.refund === '') {
      formErrors.refund = 'Refund cannot be empty';
    }

    if (formData.service === '') {
      formErrors.service = 'Service cannot be empty';
    }

    if (formData.customerName === '') {
      formErrors.customerName = 'Customer Name cannot be empty';
    }

    if (formData.cardNumber === '') {
      formErrors.cardNumber = 'Card Number cannot be empty';
    }

    if (formData.time === '') {
      formErrors.time = 'time cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return;
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/transaction/add', formData, {
      
              headers: {
                'access_token': token,
              },
      
            });

      if (response.data.Status === "SUCCESS") {
      setFormData({

        message: '',
        mode: '',
        openingBal: null,
        amount: null,
        closingBal: null,
        utr: '',
        orderId: '',
        refId: '',
        // userId: '', this is foreign key input
        date: '',
        recorn: null,
        refund: null,
        service: '',
        customerName: '',
        cardNumber: '',
        time: '',

      });
    }
    else{
      console.log(response.data.message)
    }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };
  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Transaction</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="message" className="label-custom">Message</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.message ? 'input-error' : ''}`}
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="mode" className="label-custom">Mode</label>
                      <select
                        className={`form-select ${errors.mode ? 'input-error' : ''}`}
                        id="mode"
                        name="mode"
                        value={formData.mode}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="large">Debit</option>
                        <option value="small">Credit</option>
                      </select>
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="openingBal" className="label-custom">Opening Balance</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.openingBal ? 'input-error' : ''}`}
                        id="openingBal"
                        name="openingBal"
                        value={formData.openingBal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="amount" className="label-custom">Amount</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.amount ? 'input-error' : ''}`}
                        id="amount"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block" >
                      <label htmlFor="closingBal" className="label-custom">Closing Balance</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.closingBal ? 'input-error' : ''}`}
                        id="closingBal"
                        name="closingBal"
                        value={formData.closingBal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="utr" className="label-custom">UTR</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.utr ? 'input-error' : ''}`}
                        id="utr"
                        name="utr"
                        value={formData.utr}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    {/* <div className="spacing w-50 d-inline-block" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="orderId" className="label-custom">Order ID</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.orderId ? 'input-error' : ''}`}
                        id="orderId"
                        name="orderId"
                        value={formData.orderId}
                        onChange={handleChange}
                      />
                    </div> */}

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="refId" className="label-custom">Ref ID</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.refId ? 'input-error' : ''}`}
                        id="refId"
                        name="refId"
                        value={formData.refId}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="cardNumber" className="label-custom">Card Number</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.cardNumber ? 'input-error' : ''}`}
                        id="cardNumber"
                        name="cardNumber"
                        value={formData.cardNumber}
                        onChange={handleChange}
                      />
                    </div>
            
                    </div>

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="date" className="label-custom">Date</label>
                      <input
                        type="date"
                        className={`input-custom ${errors.date ? 'input-error' : ''}`}
                        id="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="recorn" className="label-custom">Recorn</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.recorn ? 'input-error' : ''}`}
                        id="recorn"
                        name="recorn"
                        value={formData.recorn}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="refund" className="label-custom">Refund</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.refund ? 'input-error' : ''}`}
                        id="refund"
                        name="refund"
                        value={formData.refund}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="service" className="label-custom">Service</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.service ? 'input-error' : ''}`}
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block" >
                      <label htmlFor="customerName" className="label-custom">Customer Name</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.customerName ? 'input-error' : ''}`}
                        id="customerName"
                        name="customerName"
                        value={formData.customerName}
                        onChange={handleChange}
                      />
                    </div>

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="userId" className="label-custom">User ID</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.userId ? 'input-error' : ''}`}
                        id="userId"
                        name="userId"
                        value={formData.userId}
                        onChange={handleChange}
                      />
                    </div> */}
                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
